// extracted by mini-css-extract-plugin
module.exports = {"loading":"co","fullscreenWrapper":"cp","centeredSpinner":"cq","rotation":"cr","withoutLayer":"cs"};